import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=106a813c&lang=pug&"
import script from "./CampaignEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports